import React from 'react';
import {
  Box,
  IconButton,
  TextField,
  Tooltip,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  ViewColumn as ViewColumnIcon,
} from '@mui/icons-material';
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
} from '@mui/x-data-grid';

/** Toolbar: search + filter + columns + customize (AsroTrack-style). */
export function BenchmarkGridToolbar({
  quickFilterValue,
  onQuickFilterChange,
  onOpenCustomize,
}) {
  return (
    <GridToolbarContainer
      sx={{
        px: 1.5,
        py: 1,
        gap: 1,
        flexWrap: 'wrap',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <TextField
        size="small"
        placeholder="Search…"
        value={quickFilterValue || ''}
        onChange={(e) => onQuickFilterChange?.(e.target.value)}
        sx={{ width: 260, maxWidth: '100%', flex: '0 0 auto' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />
      <GridToolbarFilterButton />
      <GridToolbarColumnsButton />
      <Tooltip title="Customize columns (save view)">
        <IconButton size="small" onClick={onOpenCustomize} color="primary">
          <ViewColumnIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Box sx={{ flex: 1 }} />
    </GridToolbarContainer>
  );
}

export default BenchmarkGridToolbar;
